import { groupBy } from '@/helpers/groupBy'

export const tranformNftList = (data: any) => {
  const grouped = groupBy(data, (nft: any) => nft.type)
  return Object.entries(grouped).map(([type, nfts]) => ({
    type,
    amount: nfts.length,
  }))
}
